<ng-container *transloco="let t">
  @if (button?.type === 'basic') {
    <button
      [class]="class"
      mat-button
      [color]="button?.color"
      [disabled]="button?.disabled"
      [attr.aria-label]="button?.ariaLabel ?? button?.label"
      (click)="onClick()">
      @if (!button.disabled || (!button.disabled && !button.spinnerLoad)) {
        <ng-container *ngTemplateOutlet="iconLabelTemplate"></ng-container>
      }
      @if (button.disabled && button.spinnerLoad) {
        <ng-container *ngTemplateOutlet="spinnerProgress"></ng-container>
      }
    </button>
  }

  @if (button?.type === 'raised') {
    <button
      [class]="class"
      mat-raised-button
      [color]="button?.color"
      [disabled]="button?.disabled"
      [attr.aria-label]="button?.ariaLabel ?? button?.label"
      (click)="onClick()">
      @if (!button.disabled || (!button.disabled && !button.spinnerLoad)) {
        <ng-container *ngTemplateOutlet="iconLabelTemplate"></ng-container>
      }
      @if (button.disabled && button.spinnerLoad) {
        <ng-container *ngTemplateOutlet="spinnerProgress"></ng-container>
      }
    </button>
  }

  @if (button?.type === 'stroked' && !button?.disabled) {
    <button
      [class]="class"
      mat-stroked-button
      [color]="button?.color"
      [disabled]="button?.disabled"
      [attr.aria-label]="button?.ariaLabel ?? button?.label"
      (click)="onClick()">
      @if (!button.disabled || (!button.disabled && !button.spinnerLoad)) {
        <ng-container *ngTemplateOutlet="iconLabelTemplate"></ng-container>
      }
      @if (button.disabled && button.spinnerLoad) {
        <ng-container *ngTemplateOutlet="spinnerProgress"></ng-container>
      }
    </button>
  }

  @if (button?.type === 'flat') {
    <button
      [class]="class"
      mat-flat-button
      [color]="button?.color"
      [disabled]="button?.disabled"
      [attr.aria-label]="button?.ariaLabel ?? button?.label"
      (click)="onClick()">
      @if (!button.disabled || (!button.disabled && !button.spinnerLoad)) {
        <ng-container *ngTemplateOutlet="iconLabelTemplate"></ng-container>
      }
      @if (button.disabled && button.spinnerLoad) {
        <ng-container *ngTemplateOutlet="spinnerProgress"></ng-container>
      }
    </button>
  }

  @if (button?.type === 'icon') {
    <button
      [class]="class"
      mat-icon-button
      [color]="button?.color"
      [disabled]="button?.disabled"
      [attr.aria-label]="button?.ariaLabel ?? button?.label"
      (click)="onClick()">
      @if (!button.disabled || (!button.disabled && !button.spinnerLoad)) {
        <mat-icon
          class="icon-size-5"
        [svgIcon]="button.icon ?? ''"></mat-icon>
      }
      @if (button.disabled && button.spinnerLoad) {
        <ng-container *ngTemplateOutlet="spinnerProgress"></ng-container>
      }
    </button>
  }

  @if (button?.type === 'fab') {
    <button
      [class]="class"
      mat-fab
      [color]="button?.color"
      [disabled]="button?.disabled"
      [attr.aria-label]="button?.ariaLabel ?? button?.label"
      (click)="onClick()">
      @if (!button.disabled || (!button.disabled && !button.spinnerLoad)) {
        <mat-icon
          class="icon-size-5"
        [svgIcon]="button.icon ?? ''"></mat-icon>
      }
      @if (button.disabled && button.spinnerLoad) {
        <ng-container *ngTemplateOutlet="spinnerProgress"></ng-container>
      }
    </button>
  }

  @if (button?.type === 'miniFab') {
    <button
      [class]="class"
      mat-mini-fab
      [color]="button?.color"
      [disabled]="button?.disabled"
      [attr.aria-label]="button?.ariaLabel ?? button?.label"
      (click)="onClick()">
      @if (!button.disabled || (!button.disabled && !button.spinnerLoad)) {
        <mat-icon
          class="icon-size-5"
        [svgIcon]="button.icon ?? ''"></mat-icon>
      }
      @if (button.disabled && button.spinnerLoad) {
        <ng-container *ngTemplateOutlet="spinnerProgress"></ng-container>
      }
    </button>
  }

  @if (button?.type === 'extendFab') {
    <button
      [class]="class"
      mat-fab
      extended
      [color]="button?.color"
      [disabled]="button?.disabled"
      [attr.aria-label]="button?.ariaLabel ?? button?.label"
      (click)="onClick()">
      @if (!button.disabled || (!button.disabled && !button.spinnerLoad)) {
        <ng-container *ngTemplateOutlet="iconLabelTemplate"></ng-container>
      }
      @if (button.disabled && button.spinnerLoad) {
        <ng-container *ngTemplateOutlet="spinnerProgress"></ng-container>
      }
    </button>
  }

  <!-- Template para Ícone e Rótulo -->
  <ng-template #iconLabelTemplate>
    <div class="flex justify-center items-center">
      @if (button?.icon) {
        <mat-icon
          class="icon-size-5"
          [ngClass]="{'mr-2': hasLabel}"
        [svgIcon]="button.icon ?? ''"></mat-icon>
      }
      {{ hasLabel ? (t(button?.label ?? '') | capitalize) : '' }}
    </div>
  </ng-template>

  <ng-template #spinnerProgress>
    @if (button.disabled) {
      <mat-progress-spinner
        [diameter]="24"
        [mode]="'indeterminate'">
      </mat-progress-spinner>
    }
  </ng-template>
</ng-container>
